export const VR_DEV_DOMAIN = "byb-vr-dev.web.app";
export const VR_DEV_URL = `https://${VR_DEV_DOMAIN}/`;
